import React, {useEffect} from 'react';
import { useKeycloak } from "@react-keycloak/web";
import {authenticateKeycloak} from "./keycloak";

const SecuredPage = () => {
  const { keycloak } = useKeycloak();
  authenticateKeycloak(keycloak);

  let scope = keycloak.tokenParsed.scope;
  let sub = keycloak.tokenParsed.sub;
  let aud = keycloak.tokenParsed.aud;

  useEffect(()=>{
      document.title = 'PairCare.ai - Secured Page';
  },[])

  return (
    <div style={{textAlign: "center", minHeight: "calc(100vh - 300px)"}}>
      <h1>You are now signed in!</h1>
      <h3>Client Scopes: {scope}</h3>
        <h3>Subscriber Id: {sub}</h3>
        <h3>Audience: {aud}</h3>
        <h3 style={{maxWidth:"70pc", wordWrap:"break-word", margin:"auto"}}>Token: {keycloak.token}</h3>
    </div>
  );
};

export default SecuredPage;